import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Title, Input } from './styles/EnquiryFormInput.styled';

export default function EnquiryFormInput({ value, setValue, title, type, required }) {
  return (
    <Wrapper clicked>
      <Title>{title}</Title>
      <Input
        required={required}
        type={type}
        value={value}
        onChange={({ target }) => setValue(target.value)}
      />
    </Wrapper>
  );
}

EnquiryFormInput.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string,
  setValue: PropTypes.func,
}.isRequired;
